export const inclusionTypeOptions =[
    {text:"Unrestricted - with no disabilities",value:"780295b5-8fbe-42f0-80a9-bde0805d3be4"},
    {text:"Mixed Ability Participation",value:"6aaa5f46-c815-452b-8693-0009645982d8"},
    {text:"Restricted - with disabilities",value:"1e41a459-47cc-43a3-b186-b0ca26baa814"}
]

export const createInclusionTypeOptions = (t: any) => [
    { text: t('inclusionTypes.unrestricted'), value: "780295b5-8fbe-42f0-80a9-bde0805d3be4" },
    { text: t('inclusionTypes.mixedAbility'), value: "6aaa5f46-c815-452b-8693-0009645982d8" },
    { text: t('inclusionTypes.restricted'), value: "1e41a459-47cc-43a3-b186-b0ca26baa814" }
];